import PropTypes from 'prop-types'
import React, { Fragment } from "react";
import perMeterCalc from '../../utils/perMeterCalc'
import { Product } from './theme'
import { Tools, ToolsButtons } from '../CollectionWallpapers/theme'
import { MagnifierLink } from "../Frame/theme";
import { FaSearch } from "react-icons/fa";

const PreviewProduct = ({
  onSelect,
  width,
  height,
  selectedImage,
  index,
  perMeter,
  resized,
  isSelected,
  borderColor = '',
  borderType = 'noframe',
  borderWidth = 0,
                          selected,
  crop = defaultCrop(),
  cropImage,
                          preview,
                          onZoom
}) => {

  return (  <Fragment>
    <Product
    onClick={() => onSelect(index)}
    w={perMeterCalc(width, perMeter)}
    h={perMeterCalc(height, perMeter)}
    selectedImage={selectedImage}
    isSelected={index === isSelected}
    isDragSelected={selected && !!selected.find(s => (s.id === index && s.type === 'frame'))}
    borderColor={borderColor}
    borderType={borderType}
    borderWidth={borderWidth}
    perMeter={perMeter}
    crop={crop}
  >
      {preview && (index === isSelected) && <MagnifierLink style={{zIndex: 200000, opacity: 1}} onClick={stopPropagation(() => onZoom(`/borders/${preview}_demo.jpg`))}>
        <FaSearch/>
      </MagnifierLink>}
    <Tools
      isActive={(selectedImage && JSON.stringify(crop) === JSON.stringify(defaultCrop())) || (selectedImage && resized)}
    >
      <ToolsButtons style={{zIndex: '200000'}} onClick={stopPropagation(cropImage)}>Kadruj</ToolsButtons>
    </Tools>
  </Product></Fragment>)
}

PreviewProduct.propTypes = {
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  onSelect: PropTypes.func.isRequired,
  selectedImage: PropTypes.string,
  index: PropTypes.number.isRequired,
  perMeter: PropTypes.number.isRequired,
  isSelected: PropTypes.number.isRequired,
  preview: PropTypes.any,
  onZoom: PropTypes.any,
  borderColor: PropTypes.string,
  borderType: PropTypes.oneOf(['noframe', 'frame', 'passe-partout', 'passe-partout-deluxe']),
  borderWidth: PropTypes.number,
  crop: PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
  }),
}

const stopPropagation = cb => e => {
  e.stopPropagation()
  return cb(e)
}

const defaultCrop = () => ({ x: 0, y: 0, width: 100, height: 100 })

export default PreviewProduct



// WEBPACK FOOTER //
// ./src/components/PreviewProduct/index.js